export default { 草稿: 0, 發布: 1, 下架: 2 };
